import { z } from 'zod';
import { DEFAULT_CURRENCY } from '@shared/lib/currencies';
import type { SubmitQuoteRequest } from '@entities/rfq';

export const quoteFormSchema = z.object({
  priceAmount: z
    .string()
    .trim()
    .regex(/^\d+(\.\d{1,4})?$/, 'must be a positive decimal')
    .refine((v) => Number(v) > 0, 'must be > 0'),
  priceCurrency: z.string().regex(/^[A-Z]{3}$/, 'ISO-4217 code'),
  leadTimeDays: z.number({ invalid_type_error: 'number expected' }).int().min(1, 'min 1'),
  terms: z.string().max(8000).optional().nullable(),
  attachments: z.array(z.string().uuid()).default([]),
});

export type QuoteFormValues = z.infer<typeof quoteFormSchema>;

export function emptyQuoteForm(): QuoteFormValues {
  return {
    priceAmount: '',
    priceCurrency: DEFAULT_CURRENCY,
    leadTimeDays: 14,
    terms: '',
    attachments: [],
  };
}

export function formToRequest(values: QuoteFormValues): SubmitQuoteRequest {
  return {
    priceAmount: values.priceAmount,
    priceCurrency: values.priceCurrency,
    leadTimeDays: values.leadTimeDays,
    terms: values.terms?.trim() || null,
    attachments: values.attachments,
  };
}
